$(document).ready(function () {
  if ($(window).width() < 993 && (!window.slick)) {
    window.slick = $('.swipeableImage').slick({arrows: false, dots: true});
    console.log('Initializing Slick');
  }
});

$(window).resize(function () {
  if ((!window.slick) && $(window).width() < 993) {
    window.slick = $('.swipeableImage').slick({arrows: false, dots: true});
    console.log('Initializing Slick on Smaller Display');
  }
});

(function($) {
  var origAppend = $.fn.append;

  $.fn.append = function () {
    return origAppend.apply(this, arguments).trigger("append");
  };
})(jQuery);